import { SelectInverseIcon } from './SelectInverseIcon';

/**
 * author: Austin Andrews
 * id DAA46B9D-9215-4BF8-BDA7-52E575817ABC
 * name select-inverse
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/select-inverse.svg
 * tags
 */
export const SelectionInvertIcon = SelectInverseIcon;
export default SelectionInvertIcon